import { get, post } from "../http/platformServer";

export interface ShipmentStatsSetting {
    shopId: number;
    enabledDate: string;
    enabled: boolean;
}

export function getShipmentStatisticSetting(shopIds: number[]): Promise<ShipmentStatsSetting[]> {
    return post(shopIds[0], "/shipment_statistics/setting/list", shopIds);
}

interface SaveShipmentStatisticSettingParams {
    disableShopIds: number[];
    enableShopIds: number[];
}

export function saveShipmentStatisticSetting(
    params: SaveShipmentStatisticSettingParams,
): Promise<ShipmentStatsSetting[]> {
    const { disableShopIds, enableShopIds } = params;
    return post(enableShopIds?.[0] || disableShopIds?.[0], "/shipment_statistics/setting/save", params);
}

export interface ShipmentStats {
    /** 统计时间 */
    statisticsTime: string;
    /** 发货订单数量 */
    orderCount: number;
    /** 发货商品件数 */
    itemCount: number;
    /** 发货运单号数量 */
    waybillCount: number;

    /** 前端手动管理的值，如果有此值，代表该店铺该日期没有统计（有可能不是高级版） */
    isNull?: boolean;
}

/** 前端构建的汇总数据模型 */
export interface SummaryShipmentStats extends Omit<ShipmentStats, "shopId"> {}

export interface QueryShipStatsParams {
    dateFrom: string;
    dateTo: string;
    shopIds: number[];
    statsType: ShipStatsTypeEnum;
}

export enum ShipStatsTypeEnum {
    MONTH = "MONTH",
    DATE = "DATE",
}

export function queryShipStats(params: QueryShipStatsParams, config?): Promise<ShipmentStats[]> {
    return post(params.shopIds[0], "/shipment_stats/list", params, config);
}

export interface ShipmentStatsOverview {
    /**
     * 是否有店铺开启了发货统计
     */
    hasSettingEnabled: boolean;

    /**
     * 昨日发货订单数
     */
    yesterdayOrderCount: boolean;

    /**
     * 昨日发货商品件数
     */
    yesterdayItemCount: boolean;

    /**
     * 昨日运单号数
     */
    yesterdayWaybillCount: boolean;
}

export function getShipStatsOverview(shopId: number): Promise<ShipmentStatsOverview> {
    return get(shopId, "/shipment_stats/overview", undefined, { hideModal: true });
}
